<template>
    <div class="row justify-center position-relative" style="min-width: 1200px;min-height: 95vh">
<!--        <div class="dialogHeader position-relative ">-->
            <div class="app-fixed-header" style="width: 1200px; left: unset; top: 20px; right: 0px !important;">
                <div class="d-flex justify-content-between w-100" style="align-items: center; height: 60px;">
                    <h4 style="font-size: 26px; font-weight: 300; margin-left: 25px; ">
                        Redemption History
                    </h4>

                    <div class="d-flex" style="justify-content: space-between">
                        <q-btn @click="closeDialog" class="float-right" color="primary" dense flat icon="close">
                            <q-tooltip>Close</q-tooltip>
                        </q-btn>
                    </div>
                </div>
            </div>
<!--        </div>-->
        <div class="card q-pa-md">
            <div class="row q-col-gutter-sm">
                <template v-if="redeemHistory.length">
                    <q-timeline color="blue-10" style="font-size: 16px !important; margin-top: 50px;">
                    <template v-for="timeline in redeemHistory">
                        <q-timeline-entry>
                            <div class="p-box">
                                <div class="timeline-status">
                                    <div class="d-flex ">
                                        <div class="point-box"><span style="font-size: 28px; font-weight: 600">{{timeline.points}} </span><br><span class="bankLabel">Requested Points</span></div>
                                        <div class="point-box ml-5" v-if="timeline.status==='Accept'"><span style="font-size: 28px; font-weight: 600">{{timeline.redeemPoint}} </span><br><span class="bankLabel">Redeem Points</span></div>
                                    </div>
                                    <div class="d-flex" style="align-items: center;">
                                        <span :class="'bg-'+getColor(timeline.status)" class="timeline-status-circle">{{statusFilter(timeline.status)}}</span>
                                    </div>
                                </div>

                                <div class="row mt-3">
                                    <div class="col-4">
                                        <label style="font-size: 14px;" class="bankLabel">Created on</label>
                                        <p>{{dateTimeFilter(timeline.createdOn)}}</p>
                                    </div>
                                    <div class="col-4">
                                        <label style="font-size: 14px;" class="bankLabel">{{(timeline.status=='Reject'?'Rejected':'Approved')+' On'}}</label>
                                        <p>{{timeline.status=='Reject'?dateTimeFilter(timeline.rejectedOn):dateTimeFilter(timeline.approvedOn)}}</p>
                                    </div>
                                    <div class="col-4">
                                        <label style="font-size: 14px;" class="bankLabel" v-if="timeline.status=='Accept'">Approved by</label>
                                        <label style="font-size: 14px;" class="bankLabel" v-if="timeline.status=='Reject'">Rejected by</label>
                                        <p v-if="timeline.status=='Accept'">{{timeline.ApprovedBy?timeline.ApprovedBy.name:'-'}}</p>
                                        <p  v-if="timeline.status=='Reject'">{{timeline.RejectedBy?timeline.RejectedBy.name:'-'}}</p>
                                    </div>

                                    <div class="col-12 row" v-if="timeline.approvalObj">
                                        <div class="col-4">
                                            <label style="font-size: 14px;" class="bankLabel">Payment Mode</label>
                                            <p>{{timeline.approvalObj.paymentMode}}</p>
                                        </div>
                                        <div class="col-4" v-if="timeline.approvalObj.paymentMode!='Cash'">
                                            <label style="font-size: 14px;" class="bankLabel">{{timeline.approvalObj.paymentMode}} Number</label>
                                            <p>{{timeline.approvalObj.chequeNumber}}</p>
                                        </div>
                                        <div class="col-4" v-if="timeline.approvalObj.paymentMode!='Cash'">
                                            <label style="font-size: 14px;" class="bankLabel">Date of {{timeline.approvalObj.paymentMode}}</label>
                                            <p>{{timeline.approvalObj.dateOfCheque|dateFilter}}</p>
                                        </div>
                                    </div>

                                    <div class="col-12 mt-3 row" style="border-top: 1px solid lightgrey" v-if="timeline.approvalObj">
                                       <!-- <div class="col-6" style="border-right: 1px solid lightgrey">
                                            <ul class="scheme-total col-8 p-2 " style="list-style: none">
                                                <li class="m-0" v-if="timeline.approvalObj.isTDSAdded">
                                                    <div class="d-flex">
                                                        <span class="mr-3" style="width: auto">{{timeline.approvalObj.originalAmount?timeline.approvalObj.originalAmount:0}}</span>
                                                        <span style="font-size: 14px;" class="ml-3">Original Amount</span>
                                                    </div>
                                                </li>
                                                <li class="m-0" v-if="timeline.approvalObj.isTDSAdded">
                                                    <div class="d-flex">
                                                        <span class="mr-3" style="width: auto">{{timeline.approvalObj.tdsAmount}}</span>
                                                        <span style="width: auto;">-</span>
                                                        <span style="font-size: 14px;">TDS Percentage ({{timeline.approvalObj.tdsPercentage}} %)</span>
                                                    </div>
                                                </li>
                                                <hr style="border: 0.5px dashed #666666; width: 70%" v-if="timeline.approvalObj.isTDSAdded">
                                                <li class="m-0">
                                                    <div class="d-flex ">
                                                        <span class="mr-3 " style="width: auto">{{timeline.approvalObj.payableAmount}}</span>
                                                        <span style="width: auto;">=</span>
                                                        <span style="font-size: 14px;">{{timeline.approvalObj.isTDSAdded?'Paid':'Payable'}} Amount</span>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div> -->
                                        <div class="col-6 px-3 pt-2">
                                            <label style="font-size: 14px;" class="bankLabel">Note</label>
                                            <p>{{timeline.approvalObj.note}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </q-timeline-entry>
                    </template>
                </q-timeline>
                </template>
                <template v-else>
                    <div style="margin-top: 100px;">
                        <img src="../../assets/no_Data.png" class="w-50 d-block mx-auto" alt="">
                    </div>
                    <div class="mx-auto">
                        <h6>No history available</h6>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
  import { GET_REDEEMPTION_HISTORY } from '../../graphql/queries/schemes'

  export default {
    name: 'RedeemHistory',
    props: ['schemeId', 'partnerId'],
    data () {
      return {
        redeemHistory: [],
      }
    },
    methods: {
      async getReedemHistory () {
        let response = await this.$apollo.query({
          query: GET_REDEEMPTION_HISTORY,
          fetchPolicy: 'network-only',
          //static id for test
          // variables: {
          //   schemeId: 'b80874b2-5bcb-48a6-9cac-d09833414344',
          //   partnerId: '286ea60b-4cfb-784a-73ff-1242f1e4d370',
          // },
          variables: {
            schemeId: this.schemeId,
            partnerId: this.partnerId,
          },
        })
        this.redeemHistory = response.data.Redemption
      },
      getColor (val) {
        if (val === 'Accept') return 'green'
        else if (val === 'Reject') return 'red'
        else return 'grey'
      },
      closeDialog () {
        this.$emit('closeDialog', false)
      },
      statusFilter(status){
        if(status==='Accept') return 'Approved'
        else if(status==='Reject') return 'Rejected'
        else return status
      }
    },
    mounted () {
      this.getReedemHistory()
    },
  }
</script>

<style scoped>
    .card {
        /*text-align: center;*/
        width: 100%;
        /*padding: 30px 40px;*/
        /*margin: auto;*/
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: bottom;
        border-radius: 4px;
        box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.3);
        position: relative;
    }

    .caps {
        text-transform: capitalize
    }

    /* -- Scroll behaviour for Application History section -- */
    .scroll-box {
        width: 28vw;
        max-height: 90vh;
        overflow: auto;
        visibility: hidden;
        font-size: small;
    }

    .drag-inner-list, .scroll-box:hover {
        visibility: visible;
    }

    .scrollbox_delayed {
        transition: visibility 0.2s;
    }

    .scrollbox_delayed:hover {
        transition: visibility 0s 0.2s;
    }

    /deep/ .q-timeline__title {
        font-size: 1rem;
    }

    /deep/ .q-field--outlined .q-field__control {
        padding: 0px !important;
    }

</style>
